import { Injectable } from "@angular/core";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { Estado } from "src/app/model/estado.model";
import { SolicitacaoDevolucaoHonra } from "src/app/model/devolucao-honra.model";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { useCache } from "@bndes/bndes-ux4/bndes-angular-utils";

@Injectable({
    providedIn: 'root'
})
export class SolicitacaoDevolucaoHonraService extends FgiBackEndService<SolicitacaoDevolucaoHonra>{

    getNewEntity(): SolicitacaoDevolucaoHonra {
        return new SolicitacaoDevolucaoHonra();
    }

    protected getResourceURL(): string {
        return "front/solicitacoes-devolucao-honra";
    }

    getSolicitacaoDevolucao(id): Observable<SolicitacaoDevolucaoHonra> {
        return this.http.get(`${this.BASE_URL}/${id}`).pipe(
            catchError((e) => this.handleError(e))) as Observable<SolicitacaoDevolucaoHonra>;
    }

    getSolicitacoesDevolucao(params?: any): Observable<any> | Observable<Array<SolicitacaoDevolucaoHonra>> {
        return this.http.get(`${this.BASE_URL}`, { params: params }).pipe(
            catchError((e) => this.handleError(e))) as Observable<Array<SolicitacaoDevolucaoHonra>>;
    }

    salvarDevolucao(devolucao: SolicitacaoDevolucaoHonra, apenasValidar: boolean): Observable<any> {
        const options: any = blockUi();
        options.params.apenasValidacao = apenasValidar;
        return this.http.post(`${this.BASE_URL}/`, devolucao, options).pipe(
            catchError((e) => this.handleError(e))) as Observable<any>;
    }

    cancelarSolicitacaoDevolucao(idSolicitacaoDevolucao: number): Observable<any> {
        const options: any = blockUi();
        return this.http.post(`${this.BASE_URL}/${idSolicitacaoDevolucao}/cancelar`, options).pipe(
            catchError((e) => this.handleError(e))) as Observable<any>;
    }

    getEstados() {
        return this.http.get(`${this.BASE_URL}/estados`, useCache()).pipe(
          catchError((e) => this.handleError(e))) as Observable<Array<Estado>>;
      }

    atualizarEstorno(id, estorno): Observable<SolicitacaoDevolucaoHonra> {
        return this.http.post(`${this.BASE_URL}/${id}/atualizar-estorno-manual?estorno=${estorno}`, {}).pipe(
            catchError((e) => this.handleError(e))) as Observable<SolicitacaoDevolucaoHonra>;
    }
    
}